var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id, validationId) {
      pug_mixins["summary-box"] = pug_interp = function(selectedCompany, save, disabled, cyData){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"summary-box isTransparent\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"xsmall-12 medium-6 large-6 columns\"\u003E";
if (selectedCompany) {
pug_html = pug_html + "\u003Cspan class=\"summary-box__title\"\u003E\u003Cstrong\u003EFirma:\u003C\u002Fstrong\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = ' '+ selectedCompany) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"hide-for-small-only\"\u003E&nbsp;\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"xsmall-12 medium-6 large-6 columns text-right pull-right\"\u003E";
block && block();
if (save) {
pug_html = pug_html + "\u003Cbutton" + (" class=\"button button-primary isOutline\""+pug.attr("ng-click", save, true, true)+pug.attr("ng-disabled", disabled, true, true)+pug.attr("data-cy", cyData, true, true)) + "\u003ESpeichern\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};



















pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};



















































































































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};





























































pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv class=\"cockpit-panel\" overlay=\"$ctrl.loading\"\u003E";
pug_mixins["summary-box"]('{{ $ctrl.customer.name }}', '$ctrl.save()', '!$ctrl.canSave()');
pug_html = pug_html + "\u003Cdiv class=\"cockpit-panel__title\"\u003EAuto Abo Konfiguriation\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cp\u003ESobald eine Vertragsnummer FINN angegeben ist, können Mitarbeitende aktiv bestellen. Bitte die Angabe daher erst vornehmen, wenn die Nutzung freigegeben ist.\u003C\u002Fp\u003E\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\" overlay=\"$ctrl.loading\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EIntern\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-5\"\u003E";
pug_mixins["input"].call({
attributes: {"type": "text","key": "$ctrl.carLeasingConfigurationModel.contractNumber","title": "Vertragsnummer FINN","readonly": "!$ctrl.iAmSpecialAdvisor","validationMessages": {"pattern":"Validierung der Vertragsnummer ist fehlgeschlagen.","maxlength":"Die Vertragsnummer soll aus maximal 20 Ziffern bestehen."},"attributes": {"ng-pattern":"\u002F^[0-9]*$\u002F","ng-maxlength":"20"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-1\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-5\"\u003E\u003Cdiv\u003E\u003Clabel class=\"control-label\"\u003EVerfügbare Antriebe\u003C\u002Flabel\u003E\u003Cui-select ng-disabled=\"!$ctrl.canEdit()\" ng-model=\"avEngines.selected\" theme=\"select2\" title=\"Laufzeiten\" search-enabled=\"false\" multiple close-on-select=\"false\" style=\"width:100%\"\u003E\u003Cui-select-match placeholder=\"Select Engine\" allow-clear=\"true\"\u003E{{$item.name}}\u003C\u002Fui-select-match\u003E\u003Cui-select-choices repeat=\"engine in avEngines.options track by $index\"\u003E\u003Cspan ng-bind=\"engine.name\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fui-select-choices\u003E\u003C\u002Fui-select\u003E\u003C\u002Fdiv\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.carLeasingConfigurationModel.engines","type": "hidden","required": pug.escape(true),"validationMessages": {"required":"Bitte Eingabe prüfen"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-5\"\u003E\u003Cdiv\u003E\u003Clabel class=\"control-label\"\u003ELaufzeiten\u003C\u002Flabel\u003E\u003Cui-select ng-disabled=\"!$ctrl.canEdit()\" ng-model=\"avDuration.selected\" theme=\"select2\" title=\"Laufzeiten\" search-enabled=\"false\" multiple close-on-select=\"false\" style=\"width:100%\"\u003E\u003Cui-select-match placeholder=\"Select Duration\" allow-clear=\"true\"\u003E{{$item}}\u003C\u002Fui-select-match\u003E\u003Cui-select-choices repeat=\"duration in avDuration.options track by $index\"\u003E\u003Cspan ng-bind=\"duration\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fui-select-choices\u003E\u003C\u002Fui-select\u003E\u003C\u002Fdiv\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.carLeasingConfigurationModel.duration","type": "hidden","required": pug.escape(true),"validationMessages": {"required":"Bitte Eingabe prüfen"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-1\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-5\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.carLeasingConfigurationModel.maxLeasingsPerEmployee","title": "Anzahl Abo je Nutzer","type": "number","readonly": "!$ctrl.canEdit()","attributes": {"min":1,"max":3},"required": pug.escape(true),"validationMessages": {"required":"Bitte Eingabe prüfen"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-5\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.carLeasingConfigurationModel.maxExchange","title": "Maximale mtl. Umwandlung","required": pug.escape(true),"readonly": "!$ctrl.canEdit()","validationMessages": {"required":"Bitte Eingabe prüfen","numberOrEmpty":"Bitte Eingabe prüfen","vnMin":"Der minimale Wert beträgt {{ 0 | currency }}","vnMax":"Der maximale Wert beträgt {{ 15000 | currency }}"},"attributes": {"vn-currency":"true","vn-max":"15000","vn-min":"0"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-5\"\u003E\u003Cspan\u003ELadeinfrastruktur beim Arbeitgeber\u003C\u002Fspan\u003E\u003Cdiv class=\"columns medium-5\" ng-repeat=\"option in $ctrl.electricChargerAvailability\"\u003E";
pug_mixins["radio"].call({
attributes: {"readonly": "!$ctrl.canEdit()","id": "electricChargerAvailability-{{option.name}}","key": "$ctrl.carLeasingConfigurationModel.electricChargerAvailability","ng-value": "option.value"}
});
pug_html = pug_html + "\u003Clabel for=\"electricChargerAvailability-{{option.name}}\"\u003E{{option.name}}\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-1\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-5\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.carLeasingConfigurationModel.fee","title": "Honorar EUR","required": pug.escape(true),"readonly": "!$ctrl.canEdit()","validationMessages": {"required":"Bitte Eingabe prüfen","numberOrEmpty":"Bitte Eingabe prüfen"},"attributes": {"vn-currency":"true"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-5\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.carLeasingConfigurationModel.bringBackFee","title": "Rückholkosten EUR","required": pug.escape(true),"readonly": "!$ctrl.canEdit()","validationMessages": {"required":"Bitte Eingabe prüfen","numberOrEmpty":"Bitte Eingabe prüfen"},"attributes": {"vn-currency":"true"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-1\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-5\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.carLeasingConfigurationModel.VNFlatTax","title": "Honorar in Umwandlung","required": pug.escape(true),"readonly": "!$ctrl.canEdit()","validationMessages": {"required":"Bitte Eingabe prüfen","numberOrEmpty":"Bitte Eingabe prüfen"},"attributes": {"vn-currency":"true"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-5\"\u003E\u003Cspan\u003EZuschuss Fest Oder Variabel\u003C\u002Fspan\u003E\u003Cdiv class=\"columns medium-5\" ng-repeat=\"option in $ctrl.fuelBonusTypes\"\u003E";
pug_mixins["radio"].call({
attributes: {"readonly": "!$ctrl.canEdit()","id": "fuelBonusType-{{option.name}}","key": "$ctrl.carLeasingConfigurationModel.carFuelBonusConfig.car_fuel_bonus_type","ng-value": "option.value"}
});
pug_html = pug_html + "\u003Clabel for=\"electricChargerAvailability-{{option.name}}\"\u003E{{option.name}}\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-1\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-5\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.carLeasingConfigurationModel.carFuelBonusConfig.car_fuel_bonus_percentage","title": "Ladezuschuss %","required": pug.escape(true),"readonly": "!$ctrl.canEdit()","attributes": {"vn-percent":"{decimalsCount: 2}","vn-percent-fraction":2,"vn-min":"0","vn-max":"1","ng-disabled":"$ctrl.isBonusTypeFixed()"},"validationMessages": {"required":"Bitte Eingabe prüfen","vnMin":"Bitte geben Sie einen Wert größer 0 ein.","vnMax":"Bitte geben Sie einen Wert kleiner 1 ein.","rangeDecimalsCount":"Maximal 4 Dezimalstellen sind erlaubt"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-5\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.carLeasingConfigurationModel.carFuelBonusConfig.car_fuel_bonus_electric_fixed","title": "Electro Bonus","required": pug.escape(true),"readonly": "!$ctrl.canEdit()","validationMessages": {"required":"Bitte Eingabe prüfen","numberOrEmpty":"Bitte Eingabe prüfen","vnMin":"Bitte geben Sie einen Wert größer 0 ein.","vnMax":"Der Zuschuss darf den Betrag {{$ctrl.getMaxLegalBonusAmount(\"electric\") | currency}} nicht überschreiten."},"attributes": {"vn-currency":"true","vn-min":"0","vn-max":"{{$ctrl.getMaxLegalBonusAmount('electric')}}","ng-disabled":"!$ctrl.isBonusTypeFixed()"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-1\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-5\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.carLeasingConfigurationModel.carFuelBonusConfig.car_fuel_bonus_hybrid_fixed","title": "Hybrid Bonus","required": pug.escape(true),"readonly": "!$ctrl.canEdit()","validationMessages": {"required":"Bitte Eingabe prüfen","numberOrEmpty":"Bitte Eingabe prüfen","vnMin":"Bitte geben Sie einen Wert größer 0 ein.","vnMax":"Der Zuschuss darf den Betrag {{$ctrl.getMaxLegalBonusAmount(\"hybrid\") | currency}} nicht überschreiten."},"attributes": {"vn-currency":"true","vn-min":"0","vn-max":"{{$ctrl.getMaxLegalBonusAmount('hybrid')}}","ng-disabled":"!$ctrl.isBonusTypeFixed()"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "$ctrl.carLeasingConfigurationForm"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;